<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div
            class="box-offset"
           v-else
        >
            <div class="box-ttl-wrap">
                <div class="box-ttl">
                    Personal
                </div>
            </div>
            <div>
                <p>Please make sure your personal information is always up to date. If your primary residence or phone
                    number changes, please update it here so we can properly communicate with you. Keep in mind W2s are
                    mailed every year around mid February - therefore up-to-date address is very important.</p>
            </div>
            <div class="text-right">
                <a v-if="isMasterAdminComponent"
                   class="img-btn mr-4"
                   target="_blank"
                   :href="`/master-admin/applicants/${userInfo.id}/print`"
                >
                    <img src="/img/svg/icons-print.svg" class="mr-1" alt="">Print</a>
                <button class="btn btn--outline-primary btn--small" @click="collapseAll">Collapsible All</button>
                <button class="btn btn--outline-primary btn--small" @click="expandAll">Expand All</button>
            </div>
            <ValidationObserver ref="form">
                <div id="accordion" class="accordion mt-3">

                    <AccordionCard title="Personal Details" collapseId="collapse1" :isCollapsed="isAllCollapsed">
                        <PersonalDetailsForm
                            ref="personalInfo"
                            :user="userInfo"
                            @data-changed="updatePersonalInfo"
                        ></PersonalDetailsForm>
                    </AccordionCard>

                    <AccordionCard title="Address" collapseId="collapse2" :isCollapsed="isAllCollapsed">
                        <AddressForm
                            v-if="states"
                            ref="addressInfo"
                            :states="states"
                            :user="userInfo"
                            @data-changed="updateAddressInfo"
                        ></AddressForm>
                    </AccordionCard>

                    <AccordionCard title="Position Applying" collapseId="collapse3" :isCollapsed="isAllCollapsed">
                        <PositionApplying
                            v-if="licenses.length > 0"
                            ref="positionsInfo"
                            :viewRates="viewRates"
                            :licenses-list="licenses"
                            :positions="positions"
                            :user="userInfo"
                            @data-changed="updatePositionInfo"
                        ></PositionApplying>
                    </AccordionCard>

                    <AccordionCard title="Previous ORNA Work Experience" collapseId="collapse4"
                                   :isCollapsed="isAllCollapsed">
                        <PreviousOrnaWorkExp
                            ref="ornaInfo"
                            :variants-list="variants"
                            :user="userInfo"
                            @data-changed="updatePrevExpInfo"
                        ></PreviousOrnaWorkExp>
                    </AccordionCard>

                    <AccordionCard title="Work History" collapseId="collapse5" :isCollapsed="isAllCollapsed">
                        <WorkHistoryForm
                            ref="workInfo"
                            :countries="countries"
                            :states="states"
                            :user="userInfo"
                            @data-changed="updateWorkHistoryInfo"
                        ></WorkHistoryForm>
                    </AccordionCard>

                    <AccordionCard title="Qualifications" collapseId="collapse6" :isCollapsed="isAllCollapsed">
                        <QualificationsForm
                            ref="qualificationsInfo"
                            :languages-list="languages"
                            :user="userInfo"
                            @data-changed="updateQualificationsInfo"
                        ></QualificationsForm>
                    </AccordionCard>

                    <AccordionCard title="Educational Details" collapseId="collapse7" :isCollapsed="isAllCollapsed">
                        <EducationForm
                            ref="educationInfo"
                            :user="userInfo"
                            @data-changed="updateEducationalInfo"
                        ></EducationForm>
                    </AccordionCard>

                    <AccordionCard title="References" collapseId="collapse8" :isCollapsed="isAllCollapsed">
                        <ReferencesForm
                            ref="referencesInfo"
                            :user="userInfo"
                            @data-changed="updateReferencesInfo"
                        ></ReferencesForm>
                    </AccordionCard>

                    <AccordionCard title="Additional Questions" collapseId="collapse9" :isCollapsed="isAllCollapsed">
                        <AdditionalQuestionsForm
                            ref="questionsInfo"
                            :user="userInfo"
                            @data-changed="updateQuestionsInfo"
                            :is-master-admin="isMasterAdminComponent"
                        ></AdditionalQuestionsForm>
                    </AccordionCard>
                </div>
            </ValidationObserver>

            <div class="btns-wrap mt-4">
                <button
                    class="btn btn--outline-primary w-100 w-sm-auto"
                    @click="reloadPage"
                >Cancel
                </button>
                <button
                    class="btn btn--secondary w-100 w-sm-auto"
                    @click="validateForms"
                >Save
                </button>
            </div>
        </div>

    </div>
</template>

<script>

import PersonalDetailsForm from "../CommonForms/PersonalDetailsForm.vue";
import AddressForm from "../CommonForms/AddressForm.vue";
import PositionApplying from "../CommonForms/PositionApplyingForm.vue";
import PreviousOrnaWorkExp from "../CommonForms/PreviousOrnaWorkExp.vue";
import WorkHistoryForm from "../CommonForms/WorkHistoryForm.vue";
import QualificationsForm from "../CommonForms/QualificationsForm.vue";
import EducationForm from "../CommonForms/EducationForm.vue";
import ReferencesForm from "../CommonForms/ReferencesForm.vue";
import AdditionalQuestionsForm from "../CommonForms/AdditionalQuestionsForm.vue";
import AccordionCard from "./AccordionCard.vue";
import EmployeeInfoService from "../services/EmployeeInfoService";
import CommonService from "../services/CommonService";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";


export default {
    name: 'EmployeePersonal',
    props: {
        userInfo: {
            type: Object
        },
        isMasterAdminComponent: {
            type: Boolean
        },
        viewRates: Boolean,
    },
    mixins: [ModalHandler],
    components: {
        AccordionCard,
        AdditionalQuestionsForm,
        ReferencesForm,
        EducationForm,
        QualificationsForm,
        WorkHistoryForm,
        PreviousOrnaWorkExp,
        PositionApplying,
        AddressForm,
        PersonalDetailsForm
    },
    data() {
        return {
            dataPersonalForm: {
                name: null,
                middle_name: null,
                last_name: null,
                email: null,
                home_number: null,
                cell_number: null,
                resume_ids: [],
                retype_cell_number: null,
                ssn: null,
                age: null,
                birth_date: null
            },
            dataAddressForm: {
                address: null,
                zip: null,
                city: null,
                term_living: null,
                period_living: null,
                state: null,
            },
            dataPositionsForm: {},
            dataPrevExpForm: {
                worked_in_orna: '0',
                how_hear_id: null,
                how_hear_other: null,
                familiar_in_orna: '0',
                familiar_person_info: null
            },
            dataWorkHistoryForm: [],
            dataQualificationsForm: {
                english_proficiency: [],
                languages: [],
                working_outdoors: null,
                working_sundays: null,
                walking_long: null,
                transportation: null,
                be_photographed: null
            },
            dataEducationalForm: {
                high_school: null,
                high_school_graduated: null,
                college: null,
                college_graduated: null,
                college_diploma: null,
                prof_school: null,
                prof_school_graduated: null,
                prof_school_diploma: null,
                person_agree: null,
            },
            dataReferencesForm: {
                references: [],
                contacts: [],
            },
            dataQuestionsForm: {
                question_1: null,
                question_2: null,
                question_3: null,
                question_4: null,
                question_5: null,
                question_6: null,
                question_7: null,
                arrests: null,
                agree: true,
            },

            countries: [],
            languages: [],
            licenses: [],
            positions: [],
            states: [],
            variants: [],

            loading: true,
            isAllCollapsed: true,
        }
    },
    methods: {
        collapseAll() {
            this.isAllCollapsed = true;
        },
        expandAll() {
            this.isAllCollapsed = false;
        },
        async getListOfStates() {
            try {
                const {data: states} = await CommonService.getListOfStates()
                this.states = states
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        async getListOfPositions() {
            try {
                const {data: positions} = await CommonService.getListOfPositions()
                this.positions = positions
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        async getListOfLicenses() {
            try {
                const {data: licenses} = await CommonService.getListOfLicenses()
                this.licenses = licenses
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        async getListOfVariantsHowHear() {
            try {
                const {data: variants} = await CommonService.getListOfVariantsHowHear()
                this.variants = variants
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        async getListOfCountries() {
            try {
                const {data: countries} = await CommonService.getListOfCountries()
                this.countries = countries
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        async getListOfLanguages() {
            try {
                const {data: languages} = await CommonService.getListOfLanguages()
                this.languages = languages
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        setPersonalData() {
            for (const userKey in this.userInfo) {
                for (const formKey in this.dataPersonalForm) {
                    if (userKey === formKey) {
                        this.dataPersonalForm[userKey] = this.userInfo[formKey];
                    }
                }
            }
            this.loading = false
        },
        setAddressData() {
            for (const userKey in this.userInfo.user_address) {
                for (const formKey in this.dataAddressForm) {
                    if (userKey === formKey) {
                        this.dataAddressForm[userKey] = this.userInfo.user_address[formKey];
                    }
                }
            }
        },
        setWorkHistoryData() {
            this.dataWorkHistoryForm = this.userInfo.work_histories
        },
        setQualificationsData() {
            for (const userKey in this.userInfo.qualification) {
                for (const formKey in this.dataQualificationsForm) {
                    if (userKey === formKey) {
                        this.dataQualificationsForm[userKey] = this.userInfo.qualification[formKey];
                    }
                }
            }
        },
        setPrevOrnaExpData() {
            for (const userKey in this.userInfo.work_experience) {
                for (const formKey in this.dataPrevExpForm) {
                    if (userKey === formKey) {
                        this.dataPrevExpForm[userKey] = this.userInfo.work_experience[formKey];
                    }
                }
            }
            if (this.userInfo.work_experience) {
                this.dataPrevExpForm.how_hear_id = this.userInfo.work_experience.how_hear_id;
            } else {
                this.dataPrevExpForm.how_hear_id = 1
            }
        },
        setEducationsData() {
            for (const userKey in this.userInfo.education_details) {
                for (const formKey in this.dataEducationalForm) {
                    if (userKey === formKey) {
                        this.dataEducationalForm[userKey] = this.userInfo.education_details[formKey];
                    }
                }
            }
        },
        setReferencesData() {
            this.dataReferencesForm.references = this.userInfo.employee_references
            this.dataReferencesForm.contacts = this.userInfo.emergency_contacts
        },
        setQuestionsData() {
            for (const userKey in this.userInfo.additional_question) {
                for (const formKey in this.dataQuestionsForm) {
                    if (userKey === formKey) {
                        this.dataQuestionsForm[userKey] = this.userInfo.additional_question[formKey];
                    }
                }
            }
        },
        updatePersonalInfo(updatedPersonal) {
            this.dataPersonalForm = updatedPersonal
        },
        updateAddressInfo(updatedAddress) {
            this.dataAddressForm = updatedAddress
        },
        updatePositionInfo(updatedPositions) {
            this.dataPositionsForm = updatedPositions
        },
        updatePrevExpInfo(updatedExpOrna) {
            this.dataPrevExpForm = updatedExpOrna
        },
        updateWorkHistoryInfo(updatedWorkHistory) {
            this.dataWorkHistoryForm = updatedWorkHistory
        },
        updateQualificationsInfo(updatedQualification) {
            this.dataQualificationsForm = updatedQualification
        },
        updateEducationalInfo(updatedEducation) {
            this.dataEducationalForm = updatedEducation
        },
        updateReferencesInfo(updatedReferences) {
            this.dataReferencesForm = updatedReferences
        },
        updateQuestionsInfo(updatedAnswers) {
            this.dataQuestionsForm = updatedAnswers
        },
        setValidationErrors(form) {
            const validationErrors = [];

            for (const errorsKey in form.errors) {
                if (form.errors.hasOwnProperty(errorsKey)) {
                    if (form.errors[errorsKey].length) {
                        validationErrors.push(errorsKey);
                    }
                }
            }
            this.$showValidationErrorMessage(`These fields are empty or filled in incorrectly: ${validationErrors}`)
        },
        validateForms() {
            if (this.isMasterAdminComponent) {
                try {
                    this.updateAllData();

                } catch (error) {
                    this.$handleErrors(error)
                }
            } else {
                (async () => {
                    const form = this.$refs.form
                    const valid = await form.validate();

                    if (!valid) {
                        this.setValidationErrors(form)
                        return;
                    }
                    try {
                        this.updateAllData();

                    } catch (error) {
                        this.$handleErrors(error)
                    }
                })();
            }

        },
        updateAllData() {
            this.$showLoadingMessage()
            const updates = [
                EmployeeInfoService.updatePersonalForm(this.userInfo.id, this.dataPersonalForm),
                EmployeeInfoService.updateAddressForm(this.userInfo.id, this.dataAddressForm),
                EmployeeInfoService.updatePositionsForm(this.userInfo.id, this.dataPositionsForm),
                EmployeeInfoService.updateOrnaExpForm(this.userInfo.id, this.dataPrevExpForm),
                EmployeeInfoService.updateWorkHistoryForm(this.userInfo.id, this.dataWorkHistoryForm),
                EmployeeInfoService.updateQualificationsForm(this.userInfo.id, this.dataQualificationsForm),
                EmployeeInfoService.updateEducationsForm(this.userInfo.id, this.dataEducationalForm),
                EmployeeInfoService.updateReferencesForm(this.userInfo.id, this.dataReferencesForm),
                EmployeeInfoService.updateQuestionsForm(this.userInfo.id, this.dataQuestionsForm),
            ];
            Promise.all(updates)
                .then((responses) => {
                    if (responses) {
                        this.$showSuccessMessage();
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000)
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$showErrorMessage('Error! Please fill in the required fields');
                });
        },
    },
    mounted() {
        this.setPersonalData();
        this.setAddressData();
        this.setPrevOrnaExpData();
        this.setWorkHistoryData();
        this.setQualificationsData();
        this.setEducationsData();
        this.setReferencesData();
        this.setQuestionsData();

        this.getListOfStates();
        this.getListOfLicenses();
        this.getListOfPositions();
        this.getListOfCountries();
        this.getListOfVariantsHowHear();
        this.getListOfLanguages();
    },

}

</script>

<style scoped>

</style>
